<template lang="pug">
    MglMarker(
        ref="pin"
        anchor="bottom"
        :coordinates="marker.coordinates"
        @mouseenter="showTooltip"
        @mouseleave="hideTooltip"
    )
        .marker(slot="marker")
            h5.char(v-if="marker.char" :style="{ color: getCharColor(marker.color) }") {{ marker.char }}
            i.el-icon-fa-map-marker.fas(:style="{ color }")
        MglPopup(
            v-if="marker.title || marker.description"
            :offset="20"
            :close-button="false"
        )
            .marker-popover(
                @mouseover="showTooltip"
                @mouseout="hideTooltip"
            )
                .title(v-if="marker.title") {{ marker.title }}
                .description(v-if="marker.description" v-html="marker.description")
</template>

<script>
import Color from 'color'
import {  MglMarker, MglPopup } from 'vue-mapbox'

export default {
    name: 'Pin',
    data: () => ({
        timeout: undefined,
        delay: 100,
    }),
    props: {
        marker: {
            type: Object,
            required: true
        }
    },
    components: {
        MglMarker,
        MglPopup,
    },
    computed: {
        color() {
            return this.marker.color || '#FF3029'
        }
    },
    methods: {
        showTooltip() {
            if (this.timeout) clearTimeout(this.timeout)
            if (this.$refs.pin && this.$refs.pin.marker.getPopup() && ! this.$refs.pin.marker.getPopup().isOpen()) {
                this.$refs.pin.marker.togglePopup()
            }
        },
        hideTooltip() {
            this.timeout = setTimeout(() => {
                if (this.$refs.pin && this.$refs.pin.marker.getPopup() && this.$refs.pin.marker.getPopup().isOpen()) {
                    this.$refs.pin.marker.togglePopup()
                }
            }, this.delay);
        },
        getCharColor(hex) {
            let color = Color(hex)
            // if (color.isDark()) color = color.lighten(0.4)

            const lightness = color.lightness()
            if (lightness > 60) color = color.lightness(15)
            else color = color.lightness(95)

            return color.rgb().string()
        },
    }
}
</script>

<style lang="sass" scoped>

.marker .char
    margin: 0
    padding: 0
    position: absolute
    text-transform: uppercase
    font-size: 1rem
    width: 24px
    text-align: center
    height: 26px
    line-height: 26px
    color: white

.mapboxgl-marker
    font-size: 2rem
    line-height: 2rem
    height: 2rem
    &:after
        content: ''
        position: absolute
        width: 10px
        height: 0px
        bottom: -2px
        left: calc(50% - 5px)
        box-shadow: 0 0 4px 1px rgba(0, 0, 0, 0.8)
.marker-popover
    .title
        font-weight: bold
        line-height: 1.3
    .description
        pointer-events: none
        font-size: .9em
        line-height: 1.3
        ::v-deep p
            margin-top: 0
            margin-bottom: 4px
            &:last-child
                margin-bottom: 0
</style>
